import React from "react";

import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ServiceCategory from "./services/ServiceCategory";
import Markdown from "react-markdown";

const Services = () => {

  const slugify = (str) => {
      return str
      .toLowerCase()
      .trim()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  const getCurrentAddress = (location) => {
    return location.pathname.split("/").pop()
  }

  const navigate = useNavigate();
  const location = useLocation();
  const [pageState, setPageState] = useState("loading");
  const [dynamicContent, setDynamicContent] = useState(null);

  const pageContent = {
    loading: <>
      <h1>Loading data...</h1>
    </>,
    error: <>
      <h1>There has been an issue.</h1>
    </>,
    success: dynamicContent
  }

  useEffect(() => {(async () => {
    try {
      const res = await fetch("https://oncadevelopment.com/api/service");
      if (!res.ok) throw new Error("Failed to fetch projects");
      const data = await res.json();
      // console.log(data)

      let currentAddress = getCurrentAddress(location);
      if (!data.map(item => slugify(item.category_name)).includes(currentAddress)) {
        console.log("current url is not valid");
        const newAddress = slugify(data[0].category_name);
        navigate(`./${newAddress}`, { replace: true });
        currentAddress = newAddress;
      }

      const current = data
      .find((item) => slugify(item.category_name) === currentAddress);
      const categories = data
      .reduce((acc, val) => {
        if (
          !acc.some((item) => item.category_name === val.category_name)
        ) {
          acc.push(val)
        }
        return acc
      }, []);
      const idx = categories
        .findIndex((item) => slugify(item.category_name) === currentAddress);
      const prevIdx = (idx - 1 + categories.length) % categories.length;
      const nextIdx = (idx + 1 + categories.length) % categories.length;

      const services = data.reduce((acc, val) => {
        if (val.category_name === current.category_name) {
          acc.push({title: val.service_name, description: val.service_description});
        }
        return acc
      }, [])

      const hook = data.hook;

      setDynamicContent(<>
        <h1>Our services</h1>
        <ServiceCategory
          title={ current.category_name }
          description={ current.category_description }
          services={ services }
          hook= { current.category_hook }
        />
        <nav>
          <ul>
            {
              categories
              .map((item, index) => {
                return <li key={ index }>
                  <Link 
                    to={ `./${slugify(item.category_name)}` }
                    className={ slugify(item.category_name) === currentAddress ? "active" : "" }
                    >{ item.category_name }</Link>
                </li>
              })
            }
          </ul>
          <div className="buttons">
            <Link to={`./${slugify(categories[prevIdx].category_name)}`}>{'<'} Prev</Link>
            <Link to={`./${slugify(categories[nextIdx].category_name)}`}>Next {'>'}</Link>
          </div>
        </nav>
      </>)
      setPageState("success");


    } catch (err) {
      console.error(err)
      setPageState("error")
    }
  })()}, [location])




  return <>
    <main id="services-page">
      <Link className="breadcrumb" to="..">{"<"} Back to home page</Link>
      { pageContent[pageState] }
    </main>
    <footer>
      <Link to="/contact">
        <button>Have a project? Let's talk 👉</button>
      </Link>
    </footer>
  </>
}

export default Services;